import React from 'react';
import { useNavigate } from 'react-router-dom';
import { createQueryDataTable, type PropsOfQueryDataTable, type RowOfQueryDataTable } from '~/shared/data-tables/query/QueryDataTable';
import { RenderAddressCell } from '~/shared/data-tables/column-types/AddressColumn';
import { TableActions } from '~/shared/data-tables/TableActions';

const InsuranceProvidersDataTable = createQueryDataTable('insurance-provider');
type RowType = RowOfQueryDataTable<typeof InsuranceProvidersDataTable>;
type TableProps = PropsOfQueryDataTable<typeof InsuranceProvidersDataTable>;

function ActionsCell({ row }: { row: RowType }) {
	const navigate = useNavigate();

	return (
		<TableActions>
			<TableActions.ViewButton onClick={() => navigate(`view/${row.id}`)} />
		</TableActions>
	);
}

const columnDefinitions = InsuranceProvidersDataTable.columns([
	{
		header: 'Name',
		key: 'name',
		sortable: true,
		width: 'w-[250px]'
	},
	{
		header: 'Type',
		key: 'insuranceType',
		sortable: true
	},
	{
		header: 'Location',
		key: 'city',
		width: 'w-[200px]',
		renderCell: row => (
			<RenderAddressCell address={{ addressOne: '', city: row.city ?? '', state: row.state ?? '', zipCode: row.zipCode ?? '' }} />
		)
	},
	{
		header: 'Phone Number',
		key: 'phoneNumber',
		type: 'phone'
	},
	{
		header: 'Fax Number',
		key: 'faxNumber',
		type: 'phone'
	},
	{
		header: 'Actions',
		key: 'actions',
		width: 'w-[100px]',
		renderCell: row => <ActionsCell row={row} />
	}
]);

export function InsuranceProviderTable(props: TableProps) {
	return <InsuranceProvidersDataTable.Table columns={columnDefinitions} emptyMessage="No insurance providers found." {...props} />;
}
